export default {
    'type': 'tipo'
}